import {
  Backdrop,
  Box,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import Cards from "./Cards";
import QuotaSubmissionStatusChart from "./QuotaSubmissionStatusChart";
import { useDispatch, useSelector } from "react-redux";
import {
  getConsumptionByCountry,
  getGeoData,
  getOrderStatus,
  getQuotaSubmissionStatusData,
  getSynchronizationStatus,
  getUserCountries,
  getScenarioCriticalityList,
  resetDashboardLoading,
  setState,
} from "./dashBoardSlice";
import GeoChart from "./GeoChart";
import ConsumptionRatio from "./ConsumptionRatio";
import KPIDashboardModal from "./KPIDashboardModal";
import SearchForm from "./SearchForm";
import SynchronizationStatusModal from "./SynchronizationStatusModal";

export default function Dashboard() {
  const state = useSelector((state) => state.dashboard);
  const { isLoading, allDataLoaded } = state;
  const dispatch = useDispatch();
  const drawerOpen = useSelector((store) => store.global.drawerOpen);

  useEffect(() => {
    dispatch(resetDashboardLoading());
    dispatch(getQuotaSubmissionStatusData());
    dispatch(getConsumptionByCountry());
    dispatch(getGeoData());
    dispatch(getSynchronizationStatus());
    dispatch(getOrderStatus());
    dispatch(getUserCountries());
    dispatch(getScenarioCriticalityList());
  }, [dispatch]);

  if (!allDataLoaded) {
    return (
      <Box>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={!allDataLoaded}
        >
          <CircularProgress />
        </Backdrop>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: drawerOpen ? "70vw" : "100%" }}>
      <Box>
        <Typography variant="p18w700" sx={{ color: "blue.main", mt: 10 }}>
          Dashboard
        </Typography>
      </Box>
      <Grid
        container
        justifyContent={"flex-end"}
        columnGap={2}
        rowGap={2}
        marginTop={-5}
      >
        <Grid item>
          <KPIDashboardModal />
        </Grid>
        <Grid item>
          <SynchronizationStatusModal />
        </Grid>
      </Grid>
      <Grid sx={{ mt: 2 }} container spacing={2}>
        <Grid sx={{ flex: 1 }} item>
          <QuotaSubmissionStatusChart />
        </Grid>
        <Grid sx={{ flex: 1 }} item>
          <ConsumptionRatio />
        </Grid>
      </Grid>
      <Grid item>
        <GeoChart />
      </Grid>
      <Grid item>
        <SearchForm />
      </Grid>
    </Box>
  );
}
